<template>
    <div class="appointment-details">
        <b-card class="appointment-details">

            <h3>{{ $i18n.gt('HEADING_SELECTED_APPOINTMENT') }}</h3>
            <hr>

            <spinner-until :condition="!loadingDetails">

                <template v-if="!currentAppointment">
                    {{ $i18n.gt('MESSAGE_NO_APPOINTMENT') }}
                </template>

                <template v-else>
                    <div class="detail-header">
                        <h4>{{ $i18n.gt('LABEL_PATIENT') }}:</h4>
                        <template v-if="currentAppointment.participant">
                            <patient-id :participant="currentAppointment.participant"/>
                        </template>
                        <template v-else>
                            {{$i18n.gt('LABEL_APPOINTMENT_AVAILABLE')}}
                        </template>
                    </div>

                    <div class="detail-header">
                        <h4>{{ $i18n.gt('LABEL_DATE') }}:</h4>
                        {{ formatDayDetails(currentAppointment.start) }}
                    </div>

                    <div class="detail-header">
                        <h4>{{ $i18n.gt('LABEL_TIME') }}:</h4>
                        {{ formatTimeDetails(currentAppointment.start) }} - {{ formatTimeDetails(currentAppointment.end) }}
                    </div>

                    <div class="detail-header">
                        <h4>Actions:</h4>

                        <b-row v-if="practitionerView" class="detail-actions">
                            <b-btn @click="editAppointment">{{ $i18n.gt('LABEL_EDIT') }}</b-btn>
                            <b-btn variant="danger" @click="deleteAppointment">{{ $i18n.gt('LABEL_DELETE') }}</b-btn>
                        </b-row>

                        <b-row v-else class="detail-actions">
                            <b-btn v-if="!currentAppointment.participant" @click="claimAppointment">{{ $i18n.gt('LABEL_APPOINTMENT_CLAIM') }}</b-btn>
                            <b-btn v-else variant="danger" @click="cancelAppointment">{{ $i18n.gt('LABEL_APPOINTMENT_CANCEL') }}</b-btn>
                        </b-row>
                    </div>
                </template>
            </spinner-until>
        </b-card>
    </div>
</template>

<script>

import Vue from 'vue'
import Utils from '@/providers/Utils'

export default Vue.extend({
    name: 'AppointmentDetails',
    props: {
        practitionerView: Boolean,
        loadingDetails: Boolean,
        currentAppointment: Object,
        editAppointment: Function,
        cancelAppointment: Function,
        deleteAppointment: Function,
        claimAppointment: Function,
    },
    methods: {
        formatTimeDetails: Utils.formatTimeDetails,
        formatDayDetails: Utils.formatDayDetails,
    }
})

</script>

<style lang="scss">

</style>
